import { compose } from 'acato-utils'
import { defaultCurrencyState, getState, setPartialState } from './ui.store'

export const setCurrencyShared = compose(
  ([lens, value]) => localStorage.setItem(lens, JSON.stringify(value)),
  setPartialState('settings.currency')
)

export const getCurrencySetting = () => getState('settings.currency', defaultCurrencyState())
